import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch } from "../utils/api";
import { useAuth } from "../auth/AuthContext";
import Loading from "../components/Shared/Loading";

export default function AuthConsume() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loadMe } = useAuth();

  const token = searchParams.get("token") || "";
  const [loading, setLoading] = useState(Boolean(token));
  const [error, setError] = useState<string | null>(null);

  const consumedTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (!token) return;

    // ✅ verhindert doppelte POSTs auch bei StrictMode/Remount
    if (consumedTokenRef.current === token) return;
    consumedTokenRef.current = token;

    let isActive = true;

    const consume = async () => {
      setLoading(true);
      setError(null);

      // ✅ Wenn bereits eingeloggt, direkt weiter
      const already = await loadMe();
      if (already && isActive) {
        navigate("/portal", { replace: true });
        return;
      }

      try {
        await apiFetch("/auth/invite/consume", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        const ok = await loadMe();
        if (ok && isActive) {
          navigate("/portal", { replace: true });
        } else if (isActive) {
          setError("Anmeldung fehlgeschlagen. Bitte nutze einen neuen Einladungslink.");
        }
      } catch (err) {
        if (!isActive) return;

        // ✅ Token schon benutzt, aber wenn /me ok ist → trotzdem weiter
        const ok = await loadMe();
        if (ok && isActive) {
          navigate("/portal", { replace: true });
          return;
        }

        setError("Einladungslink ist ungueltig oder bereits verwendet.");
      } finally {
        if (isActive) setLoading(false);
      }
    };

    void consume();

    return () => {
      isActive = false;
    };
  }, [token, loadMe, navigate]);

  if (!token) {
    return (
      <div style={{ padding: "2rem" }}>
        <h1>Token fehlt</h1>
        <p>Bitte nutze deinen Einladungslink.</p>
        <Link to="/login">Zurück zum Login</Link>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Anmelden...</h1>
      {loading && <Loading />}
      {error && <p>{error}</p>}
    </div>
  );
}